// import store from "@/state/store";

export default [
    {
        path: "/login",
        name: "login",
        component: () => import("@/views/account/login"),
        meta: {
            title: "Login",
            // beforeResolve(routeTo, routeFrom, next) {
            //     if (store.getters["auth/loggedIn"]) {
            //         next({name: "dashboard"});
            //     } else {
            //         next();
            //     }
            // },
        },
    },
    {
        path: "/esqueceu-senha",
        name: "forgot-password",
        component: () => import("@/views/account/forgot-password.vue"),
        meta: {
            title: "Recuperar Senha",
        },
    },
    {
        path: "/recuperar-senha",
        name: "change-password",
        component: () => import("@/views/account/change-password.vue"),
        meta: {
            title: "Resetar Senha",
        },
    },
    {
        path: "/logout",
        name: "logout",
        component: () => import("@/views/account/logout"),
        meta: {
            title: "Logout",
        },
    },
    {
        path: "/",
        name: "dashboard",
        meta: {
            title: "Dashboard",
            authRequired: true,
        },
        component: () => import("@/views/dashboard/index"),
    },

    {
        path: "/meu-perfil",
        name: "my-profile",
        meta: {
            title: "Meu Perfil",
            authRequired: true,
        },
        component: () => import("@/views/profile/my-profile.vue"),
    },

    {
        path: "/usuarios",
        name: "users",
        meta: {
            title: "Usuários",
            authRequired: true,
            permission: 'users.index'
        },
        component: () => import("@/views/management/users.vue"),
    },

    {
        path: "/unidades",
        name: "units",
        meta: {
            title: "Unidades",
            authRequired: true,
        },
        component: () => import("@/views/units/index.vue"),
    },

    {
        path: "/contas-contabeis",
        name: "accountingAccounts",
        meta: {
            title: "Contas Contábeis",
            authRequired: true,
        },
        component: () => import("@/views/accountingAccounts/index.vue"),
    },

    {
        path: "/especies",
        name: "species",
        meta: {
            title: "Espécies",
            authRequired: true,
        },
        component: () => import("@/views/species/index.vue"),
    },

    {
        path: "/centros-de-custo",
        name: "costCenters",
        meta: {
            title: "Centros de Custo",
            authRequired: true,
        },
        component: () => import("@/views/costCenters/index.vue"),
    },

    {
        path: "/unidades-de-negocio",
        name: "businessUnits",
        meta: {
            title: "Unidades de Negócio",
            authRequired: true,
        },
        component: () => import("@/views/businessUnits/index.vue"),
    },

    {
        path: "/patrimonios",
        component: () => import("@/components/base/page-base.vue"),
        children: [
            {
                path: "",
                name: "patrimonies",
                meta: {
                    title: "Patrimônios",
                    authRequired: true,
                },
                component: () => import("@/views/patrimonies/index.vue"),
            },
            {
                path: "cadastrar",
                name: "patrimonies-register",
                meta: {
                    title: "Cadastro de Patrimônio",
                    authRequired: true,
                },
                component: () => import("@/views/patrimonies/form.vue"),
            },
            {
                path: "detalhes/:id",
                name: "patrimonies-details",
                meta: {
                    title: "Detalhes do Patrimônio",
                    authRequired: true,
                },
                component: () => import("@/views/patrimonies/details.vue"),
            },
            {
                path: "transferencia/:id",
                name: "patrimonies-movement",
                meta: {
                    title: "Transferência do Patrimônio",
                    authRequired: true,
                },
                component: () => import("@/views/patrimonies/movement.vue"),
            },
            {
                path: "editar/:id",
                name: "patrimonies-edit",
                meta: {
                    title: "Editar Patrimônio",
                    authRequired: true,
                },
                component: () => import("@/views/patrimonies/edit.vue"),
            },

            {
                path: "avaliacoes/:id",
                name: "patrimony-evaluations",
                meta: {
                    title: "Avaliaçãoes",
                    authRequired: true,
                },
                component: () => import("@/views/patrimonies/evaluation.vue"),
            },
        ],
    },

    {
        path: "/relatorios",
        name: "reports",
        meta: {
            title: "Relatórios",
            authRequired: true,
        },
        component: () => import("@/views/reports/index.vue"),
    },
];
    